import { DeleteOutlined, CopyOutlined, CheckCircleOutlined, FileTextOutlined, BulbOutlined, BranchesOutlined } from '@ant-design/icons';
import { Question } from '../types';
import { ActionButton } from './components';

interface QuestionFooterProps {
  question: Question;
  onRemove: () => void;
  onDuplicate: () => void;
  toggleRequired: () => void;
  toggleShowInReport: () => void;
  toggleHint: () => void;
  toggleDisplayRule: () => void;
}

export function QuestionFooter({
  question,
  onRemove,
  onDuplicate,
  toggleRequired,
  toggleShowInReport,
  toggleHint,
  toggleDisplayRule,
}: QuestionFooterProps) {
  return (
    <div className="flex items-center gap-1 pt-4 mt-4 border-t border-gray-200 text-gray-500">
      <ActionButton
        icon={<DeleteOutlined />}
        tooltip="Excluir"
        onClick={onRemove}
        variant="danger"
      />

      <ActionButton
        icon={<CopyOutlined />}
        tooltip="Duplicar"
        onClick={onDuplicate}
      />

      <ActionButton
        icon={<CheckCircleOutlined />}
        tooltip="Obrigatório"
        isActive={question.isRequired}
        onClick={toggleRequired}
      />

      <ActionButton
        icon={<FileTextOutlined />}
        tooltip="Exibir no laudo"
        isActive={question.showInSimplifiedReport}
        onClick={toggleShowInReport}
      />

      <ActionButton
        icon={<BulbOutlined />}
        tooltip="Adicionar dica"
        isActive={question.hasHint}
        onClick={toggleHint}
      />

      <ActionButton
        icon={<BranchesOutlined />}
        tooltip="Regra de exibição"
        isActive={question.hasDisplayRule}
        onClick={toggleDisplayRule}
      />
    </div>
  );
}
